module.exports = __webpack_public_path__ + "static/media/banner-1.a22bb3a4.jpg";